export const COMPARISON_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-layout',
  LAYOUT_LABEL: 'Comparison Layout',
  LAYOUT_DESCRIPTION: 'Side-by-side platform comparison table with feature rows and competitor columns',
  FEATURE_ICON_BASE_PATH: 'assets/images/comparison/',
  ARROW_ICON: 'assets/images/comparison/arrow-right.svg',
  PRIMARY_COMPETITOR_KEY: 'col_1',
  DEFAULT_RELEASING_SOON: 'Releasing Soon'
} as const;
